import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, Box
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json"; // Pastikan file ini ada
import { dateToStringDate } from "../Helpers"; // Pastikan fungsi ini ada

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Pmc() {
  // State untuk bagian Events
  const url_list = Config.api_domain + "/pmc/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [openAnnouncementPopup, setOpenAnnouncementPopup] = useState(true);
  const handleCloseAnnouncementPopup = () => setOpenAnnouncementPopup(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

  function getRows() {
    if (typeof list !== "undefined" && list !== null && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/pmc/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        <h2>Project Management Consultant</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          Project Management Consultant (PMC) is a party that responsible to provide technical and
          administrative assistance, consultation services including contract and procurement,
          environmental and social, and handling the complaint and other technical issues.
        </p>

        <p style={{ textAlign: "justify" }}>
          The Project Management Consultant (PMC) will play a critical role in supporting the implementation
          of the ILASP project by assisting the Project Implementation Unit (PIU) and relevant stakeholders
          in ensuring timely, efficient, and quality-driven project execution. The scope of work encompasses eightkey areas :
        </p>

        <ol style={{ textAlign: "justify" }}>
          <li>
            Project planning and coordination. Facilitate the achievement of targets outlined in Component 4:Large-Scale Base Maps for Climate Action, and coordinate activities among implementing agencies and stakeholders.
          </li>
          <li>
            Financial management. Including Develop project plans, including Annual Work Plans (AWP),budgeting, procurement, financial administration,safeguard monitoring, work progress tracking, project evaluation, and reporting. Assist PIU inintegrating the project’s work program and annual Budget plan into the government's work plan and budget implementation process.
          </li>
          <li>
            Risk management. Oversee the implementation of the Environmental and Social Framework (ESF) by ensuring compliance with action plans to mitigate project-related risks and impactsmanaging grievance resolution mechanisms, while also providing capacity building and technical support for safeguard measures relevant to BIG activities in Component 4.
          </li>
          <li>
            Procurement and contract management. Support the development of Terms of Reference (TOR),specifications, and contracts, ensuring the procurement of work, goods, and services for BIG activities under Component 4, while obtaining a No Objection Letter (NOL) from the World Bank; and conduct vender performance tracking.
          </li>
          <li>
            Technical monitoring, geospatial evaluation and reporting. Develop technical guidelines, Standard Operating Procedures (SOPs), and monitoring frameworks to supervise activities under Component 4 of ILASP Project, conduct quality assurance, and prepare and submit regular project progress reports.
          </li>
          <li>
            Management Information System. Develop Monitoring Information System (MIS) and Complaint Handling, including change management and communication, and exit management.
          </li>
        </ol>

        <p style={{ textAlign: "justify" }}>
          The PMC will provide strategic advisory, technical support, coordination, monitoring, and documentation services throughout the project lifecycle.
        </p>





        {/* Unduh Section */}
        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 500 }} aria-label="timeline table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
                <StyledTableCell>Information</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>

              <StyledTableRow>
                <StyledTableCell>1</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>16 September 2025, 10:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>29 September 2025, 12:00 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>2</StyledTableCell>
                <StyledTableCell>Submission of Expressions of Interests (EOI)</StyledTableCell>
                <StyledTableCell>16 September 2025, 10:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>29 September 2025, 12:00 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>3</StyledTableCell>
                <StyledTableCell>Shortlist Appointment</StyledTableCell>
                <StyledTableCell>29 September 2025, 12:01 (GMT+7)</StyledTableCell>
                <StyledTableCell>5 December 2025, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>4</StyledTableCell>
                <StyledTableCell>Shortlist Announcement and Issuance of RFP</StyledTableCell>
                <StyledTableCell>8 December 2025, 00:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>22 January 2026, 12:00 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>5</StyledTableCell>
                <StyledTableCell>Clarification Request Period</StyledTableCell>
                <StyledTableCell>15 December 2025, 10:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>22 January 2026, 10:00 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>6</StyledTableCell>
                <StyledTableCell>Submission of Technical and Financial Proposals</StyledTableCell>
                <StyledTableCell>8 December 2025, 00:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>3 February 2026, 12:00 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>7</StyledTableCell>
                <StyledTableCell>Opening of Tech Proposal</StyledTableCell>
                <StyledTableCell>3 February 2026, 13:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>13 February 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>8</StyledTableCell>
                <StyledTableCell>Evaluation of Technical Proposals</StyledTableCell>
                <StyledTableCell>3 February 2026, 13:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>28 April 2026, 11:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>9</StyledTableCell>
                <StyledTableCell>Technical Rank Announcement</StyledTableCell>
                <StyledTableCell>28 April 2026, 12:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>28 April 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>10</StyledTableCell>
                <StyledTableCell>Opening of Financial Proposals</StyledTableCell>
                <StyledTableCell>22 May 2026, 10:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>22 May 2026, 12:00 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>11</StyledTableCell>
                <StyledTableCell>Evaluation of Financial Proposals</StyledTableCell>
                <StyledTableCell>22 May 2026, 12:01 (GMT+7)</StyledTableCell>
                <StyledTableCell>12 June 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>12</StyledTableCell>
                <StyledTableCell>Combined Evaluation</StyledTableCell>
                <StyledTableCell>29 May 2026, 00:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>12 June 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>13</StyledTableCell>
                <StyledTableCell>Final Ranking</StyledTableCell>
                <StyledTableCell>15 June 2026, 00:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>15 June 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>14</StyledTableCell>
                <StyledTableCell>Contract Negotiation</StyledTableCell>
                <StyledTableCell>17 June 2026, 00:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>20 July 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>15</StyledTableCell>
                <StyledTableCell>Notification of Intention to Award</StyledTableCell>
                <StyledTableCell>5 October 2026, 00:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>5 October 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>16</StyledTableCell>
                <StyledTableCell>Standstill/Debriefing Period</StyledTableCell>
                <StyledTableCell>6 October 2026, 00:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>19 October 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>17</StyledTableCell>
                <StyledTableCell>Notification of Award</StyledTableCell>
                <StyledTableCell>26 August 2026, 00:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>26 August 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell>A technical issue has occurred in the SPSE system during the Notification of Award stage.</StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell>18</StyledTableCell>
                <StyledTableCell>Contract Signing</StyledTableCell>
                <StyledTableCell>27 August 2026, 00:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>4 September 2026, 23:59 (GMT+7)</StyledTableCell>
                <StyledTableCell>A technical issue has occurred in the SPSE system during the Notification of Award stage.</StyledTableCell>
              </StyledTableRow>

            </TableBody>
          </Table>
        </TableContainer>

        <p style={{ textAlign: "justify" }}>
          The package will be processed through SPSE ICB at the link:{" "}
          <a
            href="https://spseicb.lkpp.go.id/spseicb/lelang/view/2570999"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://spseicb.lkpp.go.id/spseicb/lelang/view/2570999
          </a>

        </p>

      </Container>

      {/* Popup: Opening of Financial Proposal - muncul otomatis saat halaman dibuka */}
      <Dialog open={openAnnouncementPopup} onClose={handleCloseAnnouncementPopup} maxWidth="sm" fullWidth>
        <DialogTitle>Announcement – Opening of Financial Proposal (PMC)</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Typography variant="body2">
              Please be advised that the Opening of Financial Proposal for the contract titled{" "}
              <strong>Project Management Consultant</strong> will be conducted as follows:
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <Typography variant="body2"><strong>Date:</strong> May 22, 2026</Typography>
              <Typography variant="body2"><strong>Time:</strong> 10.00 A.M (Western Indonesia Time)</Typography>
              <Typography variant="body2"><strong>Online Platform:</strong> Zoom Meeting</Typography>
            </Box>

            <Typography variant="body2">
              <strong>Join Zoom Meeting:</strong>{" "}
              <a
                href="https://big-go-id.zoom.us/j/92127554658?pwd=amQoQidkP1amX1sTK8VWmd7XBTZ4Xg.1"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#7b1fa2" }}
              >
                https://big-go-id.zoom.us/j/92127554658?pwd=amQoQidkP1amX1sTK8VWmd7XBTZ4Xg.1
              </a>
            </Typography>

            <Typography variant="body2">
              <strong>Meeting Chat Link:</strong>{" "}
              <a
                href="https://big-go-id.zoom.us/launch/jc/92127554658"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#7b1fa2" }}
              >
                Open Chat
              </a>
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <Typography variant="body2"><strong>Meeting ID:</strong> 921 2755 4658</Typography>
              <Typography variant="body2"><strong>Passcode:</strong> B3#bz%Fa</Typography>
              <Typography variant="body2"><strong>Join by SIP:</strong> 92127554658@zoomcrc.com</Typography>
            </Box>

            <Typography variant="body2">
              <strong>Join Instructions:</strong>{" "}
              <a
                href="https://big-go-id.zoom.us/meetings/92127554658/invitations?signature=x9Jufaio5nnt5XlWN_c9-WLE6Ke3g1u7Ui3LqL4L6v8"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#7b1fa2" }}
              >
                https://big-go-id.zoom.us/meetings/92127554658/invitations
              </a>
            </Typography>

            <Typography variant="body2">Thank you for your attention.</Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAnnouncementPopup} variant="contained" sx={{ backgroundColor: "#7b1fa2", "&:hover": { backgroundColor: "#6a1b9a" } }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Pmc;
